import imageCompression from 'browser-image-compression';

export interface CompressOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  initialQuality?: number;
  /** Fuerza el tipo de salida (p. ej. 'image/jpeg' para rutas de storage predecibles). */
  fileType?: string;
}

/**
 * Compress an image client-side before upload to keep Supabase storage usage low.
 * Target ~200 KB (maxSizeMB default 0.2) and max 800px on the longest side.
 * Falls back to the original file if compression fails (e.g. unsupported format).
 */
export async function compressImage(file: File, opts: CompressOptions = {}): Promise<File> {
  const options: Record<string, unknown> = {
    maxSizeMB: opts.maxSizeMB ?? 0.2,
    maxWidthOrHeight: opts.maxWidthOrHeight ?? 800,
    useWebWorker: true,
    initialQuality: opts.initialQuality ?? 0.8,
  };
  if (opts.fileType) options.fileType = opts.fileType;

  try {
    return await imageCompression(file, options);
  } catch (err) {
    console.warn('[compressImage] compression failed, using original file:', err);
    return file;
  }
}

/** Resolve a storage file extension from a File/Blob mime type. */
export function extensionForMime(type: string): string {
  if (type === 'image/png') return 'png';
  if (type === 'image/webp') return 'webp';
  return 'jpg';
}
